import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocTeamAlertIssueSyncingDetailRoute: InvariantJiraRoute = {
	name: 'eoc-team-alert-issue-syncing-detail',
	path: '/jira/ops/teams/:teamId/syncs/:syncId',
	exact: true,
};
